// extracted by mini-css-extract-plugin
module.exports = {"container":"BillerDetails_container__326xg","title":"BillerDetails_title__1i6ia","header":"BillerDetails_header__3ABZ0","row":"BillerDetails_row__2uOhn"};